export default __webpack_public_path__ + "static/media/drive_to_win.38abc157.svg";